import IconCloseImport from 'components/Icons/IconClose/IconClose.svg?react';

export const IconClose = IconCloseImport;
